import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

export const passwordChangeGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Only apply on protected routes (not on login)
  if (state.url.includes('login') || state.url.includes('cambiar-contrasena')) {
    return true;
  }

  // Check if user is logged in
  if (!authService.userIsLoggedIn()) {
    return true;
  }

  const currentUser = authService.getCurrentUser();
  
  // Check if it's first login or if password expired
  const firstLogin = currentUser.claims?.firstLogin || false;
  const passwordExpired = currentUser.claims?.passwordExpired || false;

  if (firstLogin || passwordExpired) {
    // Redirect to password change page
    router.navigate(['/cambiar-contrasena']);
    return false;
  }

  return true;
};
